/**
 * Location Detail Page
 */

import { MapPin } from 'lucide-react'
import { CatalogDetailPage } from './CatalogDetailPage'
import { useTranslation } from '@/hooks/useTranslation'

export function LocationDetailPage() {
  const { t } = useTranslation()

  return (
    <CatalogDetailPage
      config={{
        endpoint: 'ubications',
        basePath: '/locations',
        title: t('catalogs.locations'),
        editLabel: t('catalogs.editLocation'),
        icon: MapPin,
        fields: [
          { key: 'code', label: t('articles.code') },
          { key: 'name', label: t('clients.name') },
          { key: 'description', label: t('articles.description') },
        ],
      }}
    />
  )
}
